import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import { Typography } from '@/components/Atoms';
import { CloseIcon } from '@/components/Svg';
import { formatNumber } from '@/utils/formatNumber';
import { useStore } from '@/zustand/store/store';
import styles from './index.module.scss';

const CommandPointList = () => {
  const { rankConfig, setShowPointList } = useStore();
  const currentPoint = rankConfig.currentPoint;
  const badgeItems = useRef(null);
  const [badgeWidth, setBadgeWidth] = useState(0);

  function convertRankArray(rankArray) {
    let result: Array<{
      image?: string;
      start_point: number;
      end_point: number;
    }> = [];

    for (let i = 1; i < rankArray?.length; i++) {
      result.push({
        image: rankArray[i].rank_badge_image,
        start_point: rankArray[i - 1].rank_xp,
        end_point: rankArray[i].rank_xp,
      });
    }

    return result;
  }

  const rankArray = convertRankArray(rankConfig.ranks);

  const minBadgeWidth = 120; // Minimum width for badges

  useEffect(() => {
    const availableWidth = badgeItems.current.clientWidth - 20;
    const calculatedWidth = availableWidth / rankArray.length;

    setBadgeWidth(Math.max(minBadgeWidth, calculatedWidth));
  }, [badgeItems, rankArray.length]);

  return (
    <div className={styles.wrapper}>
      <button className='absolute top-2 left-2' onClick={() => setShowPointList(false)}>
        <CloseIcon width={20} height={20} />
      </button>
      <div className={styles.progressBarContainer} ref={badgeItems}>
        {rankArray.map((badge, index) => {
          let progressPercentage = 0;

          if (currentPoint > badge.start_point && currentPoint < badge.end_point) {
            // Calculate percentage of completion between start_point and end_point
            progressPercentage = ((currentPoint - badge.start_point) / (badge.end_point - badge.start_point)) * 100;
          } else if (currentPoint >= badge.end_point) {
            // If currentPoint is beyond end_point, the bar should be fully blue
            progressPercentage = 100;
          }

          return (
            <div key={index} className={classNames(styles.badge)} style={{ width: badgeWidth + 'px' }}>
              {badge.image && (
                <div className={`ms-auto translate-x-[55%] ${index === rankArray.length - 1 && ''} w-[52px] h-auto relative`}>
                  <Image src={badge.image} alt={`Badge ${index + 1}`} layout='responsive' width={'100%'} height={'100%'} objectFit='contain' />
                </div>
              )}
              <div className='relative h-2 bg-[#393434] bg-opacity-50 w-full'>
                <div className='absolute left-0 top-0 h-2 bg-[#00AB55]' style={{ width: `${progressPercentage}%` }}></div>
              </div>
              <div className='flex w-full justify-between'>
                <Typography size='s14ToS12' className='-translate-x-[50%] mt-1'>
                  {formatNumber(badge.start_point, 1)}
                </Typography>
                {index === rankArray.length - 1 && (
                  <Typography size='s14ToS12' className='mt-1 -me-3'>
                    {formatNumber(badge.end_point, 1)}
                  </Typography>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default CommandPointList;
